import script from "./DuplicateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateModal.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateModal.vue?vue&type=style&index=0&id=d3e43ee4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3e43ee4"]])

export default __exports__